(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mos-for-business"] && !Shopify.designMode) return;
  try {
    
  // Foundation baseline carousel (same behaviour as homepage Foundation Formulas)
  (function(){
    const track=document.getElementById('baseTrack');
    const tabs=document.querySelectorAll('.fb-base__tab');
    const cards=track.querySelectorAll('.fb-base__card');
    let index=0;
    function slideW(){const s=getComputedStyle(track);const g=parseFloat(s.gap||s.columnGap||'0');return cards[0].getBoundingClientRect().width+g;}
    function goTo(i){index=Math.max(0,Math.min(cards.length-1,i));track.style.transform=`translateX(${-index*slideW()}px)`;tabs.forEach((t,ti)=>t.classList.toggle('is-active',ti===index));}
    tabs.forEach(t=>t.addEventListener('click',()=>goTo(parseInt(t.dataset.target,10))));
    let sx=0,cx=0,drag=false,pid=null;
    track.addEventListener('pointerdown',e=>{drag=true;sx=e.clientX;cx=0;pid=e.pointerId;track.setPointerCapture(pid);track.classList.add('is-dragging');});
    track.addEventListener('pointermove',e=>{if(!drag)return;cx=e.clientX-sx;track.style.transform=`translateX(${-index*slideW()+cx}px)`;});
    function end(){if(!drag)return;drag=false;track.classList.remove('is-dragging');const th=slideW()*0.18;if(cx<-th)goTo(index+1);else if(cx>th)goTo(index-1);else goTo(index);cx=0;}
    track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);track.addEventListener('pointerleave',end);
    window.addEventListener('resize',()=>goTo(index));
    goTo(0);
  })();
  // FAQ accordion
  document.querySelectorAll('.fb-faq__item .fb-faq__q').forEach(q=>{
    q.addEventListener('click',()=>q.parentElement.classList.toggle('open'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos-foundation-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mos-ff__track').forEach(function (track) {
      var section = track.closest('.mos-ff');
      var tabs = section.querySelectorAll('.mos-ff__tab');
      var cards = track.querySelectorAll('.mos-ff__card');
      var index = 0;

      function slideWidth() {
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0');
        return cards[0].getBoundingClientRect().width + gap;
      }
      function goTo(i) {
        index = Math.max(0, Math.min(cards.length - 1, i));
        track.style.transform = 'translateX(' + (-index * slideWidth()) + 'px)';
        tabs.forEach(function (t, ti) {
          t.classList.toggle('is-active', ti === index);
          t.setAttribute('aria-selected', ti === index ? 'true' : 'false');
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.dataset.target, 10)); });
      });
      section.querySelector('.mos-ff__tabs').addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { goTo(index + 1); tabs[index].focus(); }
        if (e.key === 'ArrowLeft')  { goTo(index - 1); tabs[index].focus(); }
      });

      // Pointer drag / touch swipe
      //
      // Capture is taken on the first real movement, NOT on pointerdown.
      // Capturing immediately retargets the rest of the gesture to the track,
      // which swallowed the click on each card's "Learn more" link — the hrefs
      // were correct but a plain click never navigated to the product page.
      // Deferring it means a click stays a click, and only becomes a drag once
      // the pointer has actually travelled.
      var DRAG_SLOP = 6;
      var startX = 0, currentX = 0, dragging = false, capturing = false, pointerId = null;

      track.addEventListener('pointerdown', function (e) {
        dragging = true; capturing = false; startX = e.clientX; currentX = 0;
        pointerId = e.pointerId;
      });

      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        currentX = e.clientX - startX;

        if (!capturing) {
          if (Math.abs(currentX) <= DRAG_SLOP) return;  // still just a click
          capturing = true;
          try { track.setPointerCapture(pointerId); } catch (err) {}
          track.classList.add('is-dragging');
        }

        track.style.transform = 'translateX(' + (-index * slideWidth() + currentX) + 'px)';
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;

        // Never crossed the slop threshold: no transform was applied and no
        // capture taken, so leave the event alone and let the click through.
        if (!capturing) { currentX = 0; return; }

        capturing = false;
        track.classList.remove('is-dragging');
        var threshold = slideWidth() * 0.18;
        if (currentX < -threshold) goTo(index + 1);
        else if (currentX > threshold) goTo(index - 1);
        else goTo(index);
        currentX = 0;
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // Wheel: trackpad horizontal or shift+scroll
      var wheelCooldown = false;
      section.addEventListener('wheel', function (e) {
        var horizontalIntent = Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey;
        if (!horizontalIntent) return;
        e.preventDefault();
        if (wheelCooldown) return;
        var delta = e.shiftKey ? e.deltaY : e.deltaX;
        if (delta > 8)       { goTo(index + 1); wheelCooldown = true; }
        else if (delta < -8) { goTo(index - 1); wheelCooldown = true; }
        if (wheelCooldown) setTimeout(function () { wheelCooldown = false; }, 500);
      }, { passive: false });

      window.addEventListener('resize', function () { goTo(index); });
      goTo(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos-inside-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mos-inside').forEach(function (section) {
      var tabs = section.querySelectorAll('.mos-inside__tab');
      var panels = section.querySelectorAll('.mos-inside__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = parseInt(tab.dataset.panel, 10);
          tabs.forEach(function (t, ti) {
            t.classList.toggle('is-active', ti === i);
            t.setAttribute('aria-selected', ti === i ? 'true' : 'false');
          });
          panels.forEach(function (p, pi) {
            p.classList.toggle('is-active', pi === i);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos-product-overview"] && !Shopify.designMode) return;
  try {
    
  // "See full ingredients list & supplement facts": open the Supplement Facts
  // accordion in the buy box and bring it into view, below the sticky header.
  // Falls back to the plain anchor if the panel is not on the page.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-mpo-facts]');
    if (!link) return;
    var table = document.querySelector('.supplement-facts__table');
    var card = table && table.closest('.card-widget');
    if (!card) return;
    e.preventDefault();
    var toggle = card.querySelector('[data-js-title]');
    if (toggle && toggle.getAttribute('aria-expanded') === 'false') toggle.click();
    var top = card.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
